/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespShopByModule_componentModule = {
    readonly title: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly linkData: {
            readonly path: string | null;
        };
        readonly " $fragmentRefs": FragmentRefs<"HpRespShopByModuleItem_item">;
    } | null> | null;
    readonly " $refType": "HpRespShopByModule_componentModule";
};
export type HpRespShopByModule_componentModule$data = HpRespShopByModule_componentModule;
export type HpRespShopByModule_componentModule$key = {
    readonly " $data"?: HpRespShopByModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespShopByModule_componentModule">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "HpRespShopByModule_componentModule",
  "type": "ShopByModule",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "items",
      "storageKey": null,
      "args": null,
      "concreteType": "Product",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "cmsId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "linkData",
          "storageKey": null,
          "args": null,
          "concreteType": "LinkData",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "path",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "HpRespShopByModuleItem_item",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'c5332c47810ed1c59a2c85a5684a5cc7';
export default node;
